import $ from "jquery";


function init() {

    $('body').on('click', '.search-btn_js', function(){
        $('.search-section').fadeIn();
        $( ".search-field" ).trigger( "focus" );
    });

    $('body').on('click', '.search-close, .search-section', function(e){
        if (e.target.className !== 'search-field') {
            $('.search-section').fadeOut();
        }
    });

    document.addEventListener('keydown', function(event) {
        //event.preventDefault();
        if (event.code == 'KeyK' && (event.ctrlKey || event.metaKey)) {
            if ($('.search-section').is(':hidden')){
                $('.search-section').fadeIn();
                $( ".search-field" ).trigger( "focus" );
            } else {
                $('.search-section').fadeOut();
            }
        }
    });

}

export default {
    init
}